// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from 'react-query'

import { submitObjectData } from '@/services/templates'
import { ObjectData } from '@/services/tcc/configurator'
import { queryKey as getTemplateQueryKey } from './useGetTemplate'

type Variables = {
  file: File
  templateId: string
}

export const useUploadObjectData = (): UseMutationResult<
  ObjectData[],
  Error,
  Variables
> => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ file, templateId }) => submitObjectData(file, templateId),
    {
      onSuccess: async (_, { templateId }) => {
        await queryClient.invalidateQueries(getTemplateQueryKey(templateId))
      },
    }
  )
}
